var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.316 0.988773C21.8242 -0.329591 23.5788 -0.329591 24.087 0.988772L25.9779 5.89415C28.5127 12.4697 33.4186 17.6899 39.5984 20.387L44.4737 22.5149C45.6735 23.0385 45.7232 24.827 44.5546 25.4251L38.236 28.6592C32.8814 31.3998 28.6214 36.0831 26.2218 41.867L24.0715 47.05C23.546 48.3167 21.857 48.3167 21.3315 47.05L19.1812 41.867C16.7816 36.0831 12.5216 31.3998 7.16702 28.6592L0.848422 25.4251C-0.320226 24.827 -0.27054 23.0385 0.92927 22.5149L5.80461 20.387C11.9844 17.6899 16.8903 12.4697 19.425 5.89415L21.316 0.988773Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.971 0.332432C44.1404 -0.110811 44.7253 -0.110811 44.8947 0.332432L45.525 1.98165C46.3699 4.19241 48.0052 5.94747 50.0651 6.85426L51.6902 7.56965C52.0902 7.74571 52.1067 8.34701 51.7172 8.54811L49.611 9.63541C47.8261 10.5568 46.4061 12.1314 45.6063 14.076L44.8895 15.8185C44.7143 16.2444 44.1513 16.2444 43.9762 15.8185L43.2594 14.076C42.4595 12.1314 41.0395 10.5568 39.2547 9.63541L37.1485 8.54811C36.7589 8.34701 36.7755 7.74571 37.1754 7.56965L38.8005 6.85426C40.8605 5.94747 42.4958 4.19241 43.3407 1.98165L43.971 0.332432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogo);
export default __webpack_public_path__ + "static/media/AI-Logo.9a523259d5dfce627e905b37cd7eb07c.svg";
export { ForwardRef as ReactComponent };